"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WarningOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.75 26l-12-22a2 2 0 00-3.52 0l-12 22A2 2 0 004 29h24a2 2 0 001.75-3zM4 27L16 5l12 22z"/><path d="M16 22.5a1.49 1.49 0 00-1.5 1.5 1.5 1.5 0 001.5 1.5 1.49 1.49 0 001.5-1.5 1.48 1.48 0 00-1.5-1.5zM16 11a1.68 1.68 0 00-1.74 1.79l.69 6.4a1.09 1.09 0 002.11 0l.68-6.4A1.67 1.67 0 0016 11z"/>';
var WarningOutlineSVG = function WarningOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.WarningOutlineSVG = WarningOutlineSVG;
WarningOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WarningOutlineSVG);
exports.default = _default;